var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.08001 4L10.562 12.101C10.8457 12.4558 11.0002 12.8967 11 13.351V20L13 18.5V13.35C13 12.896 13.1545 12.4556 13.438 12.101L19.92 4H4.08101H4.08001ZM4.08001 2H19.92C20.2968 2.00005 20.6659 2.10652 20.9848 2.30717C21.3037 2.50781 21.5595 2.79445 21.7226 3.13409C21.8857 3.47372 21.9496 3.85253 21.9069 4.22687C21.8641 4.60122 21.7165 4.95588 21.481 5.25L15 13.35V18.5C15 18.8105 14.9277 19.1167 14.7889 19.3944C14.65 19.6721 14.4484 19.9137 14.2 20.1L12.2 21.6C11.9029 21.8229 11.5495 21.9586 11.1796 21.9919C10.8097 22.0253 10.4378 21.955 10.1056 21.7889C9.77337 21.6227 9.49398 21.3674 9.29871 21.0515C9.10344 20.7355 9.00001 20.3714 9.00001 20V13.35L2.51901 5.25C2.28353 4.95588 2.13591 4.60122 2.09317 4.22687C2.05043 3.85253 2.1143 3.47372 2.27743 3.13409C2.44056 2.79445 2.69631 2.50781 3.01522 2.30717C3.33413 2.10652 3.70323 2.00005 4.08001 2Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.555eeae635c2e77b461c5391d51a1d9e.svg";
export { ForwardRef as ReactComponent };